import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import s from './SellingPoints.scss';

interface ISellingPointProps {
    title: string;
    text: string[];
    boldKeys: number[];
    cta: string;
    icon: string;
    iconFirst?: boolean;
    onClick: () => void;
}

function SellingPoint({
	title,
	text,
	boldKeys,
	cta,
	icon,
	iconFirst,
	onClick,
}: ISellingPointProps) {
	useStyles(s);
	return (
		<div
			className={`sl-teams-selling-point${iconFirst ? ' sl-teams-selling-point__icon-first' : ''
			}`}
		>
			<div
				className={`sl-teams-selling-point__content sl-teams-selling-point__content__${iconFirst ? 'right' : 'left'
				}`}
			>
				<div className="sl-teams-selling-point__content__title">
					{title}
				</div>
				<div className="sl-teams-selling-point__content__description">
					{text.map((segment, index) => (
						<span
							key={index}
							className={
								boldKeys.includes(index)
									? 'sl-teams-selling-point__content__description__bold'
									: ''
							}
						>
							{segment}
						</span>
					))}
				</div>
				<Button onClick={onClick} buttonType="secondary">
					{cta}
				</Button>
			</div>
			<div className="sl-teams-selling-point__icon">
				<img
					src={`https://blob.sololearn.com/web-assets/${icon}.png`}
					alt={icon}
				/>
			</div>
		</div>
	);
}

interface ISellingPointsProps {
    onClick: () => void;
}

export function SellingPoints({ onClick }: ISellingPointsProps) {
	useStyles(s);
	return (
		<div className="sl-teams-selling-points">
			<div className="sl-teams-selling-points__title">
				Why employees learn tech skills more effectively on Sololearn
			</div>
			<div className="sl-teams-selling-points__container">
				<SellingPoint
					title="Mobile lessons in under 5 mins"
					text={[
						'Don’t block your staff all day in training. Our 5-minute lessons can be done anytime, from anywhere, ',
						'fitting perfectly into breaks, ',
						'commutes, and other free time.',
					]}
					boldKeys={[1]}
					cta="Start today"
					icon="teams-selling-point-1"
					onClick={onClick}
				/>
				<SellingPoint
					title="Innovative learning tech"
					text={[
						'Sololearn’s smooth and interactive drag-and-drop and fill-the-gaps interface makes learning as ',
						'fast and friction-free ',
						'as possible.',
					]}
					boldKeys={[1]}
					cta="See for yourself"
					icon="teams-selling-point-2"
					iconFirst
					onClick={onClick}
				/>
				<SellingPoint
					title="Learn by doing"
					text={[
						'Learners work with real code to solve real-life problems in practical, ',
						'hands-on exercises proven to build competency faster ',
						'than traditional theory-focused learning.',
					]}
					boldKeys={[1]}
					cta="Try it out"
					icon="teams-selling-point-3"
					onClick={onClick}
				/>
				<SellingPoint
					title="Strengthen team bonds"
					text={[
						'Teams have fun competing with each other and stay engaged, thanks to ',
						'a social learning experience ',
						'that strengthens your company culture.',
					]}
					boldKeys={[1]}
					cta="Socialize your team"
					icon="teams-selling-point-4"
					iconFirst
					onClick={onClick}
				/>
				<SellingPoint
					title="Reward your employees"
					text={[
						'Course completion certificates and other ',
						'celebrations of learning milestones ',
						'keep your employees motivated, which has a positive impact on your staff retention rates.',
					]}
					boldKeys={[1]}
					cta="Reward your people"
					icon="teams-selling-point-5"
					onClick={onClick}
				/>
			</div>
		</div>
	);
}
